import { gql } from "apollo-boost";

export const GET_OFFERS = gql`
  query getOffers {
    getOffers {
      id
      name
      description
      code
      discountValueType
      discountValue
      validFrom
      validTo
      status
      branchIds
      conditions {
        field
        operator
        values
      }
    }
  }
`;
